module.exports = __webpack_public_path__ + "static/media/step7.d23c98b1.png";